<template>
    <div class="container-fluid">
        <br>
        <p class="text-header">FARMERS</p>
       
        <div class="account-details">
            <div class="table table-responsive">
                <div class="contract-header">
                    <div> <span class="badge badge-primary">{{ modelCount }}</span> FARMER(S) </div>
                    <div><button @click="createFarmer">Add Farmer</button></div>
                </div>
    
                <div class="table table-responsive table-sm">
                    <div class="mb-3">
                    <input 
                        type="text" 
                        class="form-control"
                        placeholder="Search..."
                        v-model="search"
                    />
                    </div>

                    <v-data-table
                        :headers="header"
                        :items="desserts"
                        dense
                        :search="search"
                        class="table-striped table-bordered table-responsive farmer-table"
                        >

                        <template v-slot:item.status="{ item }">
                            <div class="a-text">
                               <span v-if="item.status == 'pending'" class="text-warning">{{ item.status }}</span> 
                               <span v-if="item.status == 'declined'" class="text-danger">{{ item.status }}</span> 
                               <span v-if="item.status == 'accepted'" class="text-success">{{ item.status }}</span> 
                               <span v-if="item.status == 'transfered'" class="text-primary">{{ item.status }}</span> 
                            </div>
                        </template>
                       
                        <template  v-slot:item.wallet="{ item }">
                            <div class="d-flex flex-row">
                                <button @click="openWalletModal(item.customerId, item.fullname, item.phone)" class="btn btn-success btn-sm" style="font-size:12px;">
                                CREATE ACCOUNT
                                </button>
                            </div>
                        </template> 
                    </v-data-table>
                </div>
            </div>
        </div>
         <!-- create farmer -->
         <div v-if="createFarmerModel" class="modal-backdrop-custom">
            <div class="modal-wrapper">
                <div class="modal-subs modal-lg shadow-lg rounded-3 overflow-hidden bg-white">

                <!-- Header -->
                <div class="modal-header subs-content text-white">
                    <h5 class="modal-title">
                    <i class="bi bi-person-check"></i> Create Farmer
                    </h5>
                    <button type="button" class="btn-close btn-close-white" @click="closeModal"></button>
                </div>

                <!-- Body -->
                <div class="modal-body p-4 modal-body-scroll">

                <!-- Toggle Buttons -->
                <div class="mb-4 text-center">
                <button
                    class="btn"
                    :class="isBulk ? 'btn-outline-primary' : 'btn-primary'"
                    @click="isBulk = false">
                    Single Farmer
                </button>

                <button
                    class="btn ms-2"
                    :class="isBulk ? 'btn-primary' : 'btn-outline-primary'"
                    @click="isBulk = true">
                    Bulk Upload
                </button>
                </div>
                <!-- ===================== SINGLE FARMER FORM ====================== -->
                <div v-if="!isBulk">
                <div class="user-info px-3">
                    <div class="row">

                    <!-- First Name -->
                    <div class="col-md-4 mb-3">
                        <label class="text-muted">First Name</label>
                        <input type="text" class="form-control"
                        v-model="firstName" placeholder="Enter first name">
                    </div>

                    <!-- Last Name -->
                    <div class="col-md-4 mb-3">
                        <label class="text-muted">Last Name</label>
                        <input type="text" class="form-control"
                        v-model="lastName" placeholder="Enter last name">
                    </div>

                    <!-- Middle Name -->
                    <div class="col-md-4 mb-3">
                        <label class="text-muted">Middle Name</label>
                        <input type="text" class="form-control"
                        v-model="middleName" placeholder="Enter middle name">
                    </div>

                    <!-- Email -->
                    <div class="col-md-6 mb-3">
                        <label class="text-muted">Email Address</label>
                        <input type="email" class="form-control"
                        v-model="emailAddress" placeholder="Enter email address">
                    </div>

                    <!-- Phone -->
                    <div class="col-md-6 mb-3">
                        <label class="text-muted">Mobile Number</label>
                        <input type="text" class="form-control"
                        v-model="mobileNumber" placeholder="Enter phone number">
                    </div>

                    <!-- BVN -->
                    <div class="col-md-6 mb-3">
                    <label class="text-muted">BVN</label>
                    <input
                        type="text"
                        class="form-control"
                        v-model="bvn"
                        placeholder="Enter BVN"
                        maxlength="11"
                        pattern="\d{11}"
                        @input="validateBVN"
                    >
                    <small v-if="bvnError" class="text-danger">
                        BVN must be 11 digits
                    </small>
                    </div>

                    <!-- NIN -->
                    <div class="col-md-6 mb-3">
                    <label class="text-muted">NIN</label>
                    <input
                        type="text"
                        class="form-control"
                        v-model="nin"
                        placeholder="Enter NIN"
                        maxlength="11"
                        pattern="\d{11}"
                        @input="validateNIN"
                    >
                    <small v-if="ninError" class="text-danger">
                        NIN must be 11 digits
                    </small>
                    </div>


                    <!-- DOB -->
                    <div class="col-md-4 mb-3">
                        <label class="text-muted">Date of Birth</label>
                        <input type="date" class="form-control" v-model="dob">
                    </div>

                    <!-- STATE -->
                    <div class="col-md-4 mb-3">
                        <label class="text-muted">State</label>
                        <select class="form-control" v-model="state">
                        <option value="">Select State</option>
                        <option v-for="s in states" :key="s" :value="s">
                            {{ s }}
                        </option>
                        </select>
                    </div>

                    <!-- LGA -->
                    <div class="col-md-4 mb-3">
                        <label class="text-muted">LGA</label>
                        <input type="text" class="form-control" placeholder="Enter LGA" v-model="lga">
                    </div>

                    <!-- COOPERATIVE -->
                    <div class="col-md-6 mb-3">
                        <label class="text-muted">Cooperative</label>
                        <input type="text" class="form-control" v-model="cooperative" placeholder="Enter name of cooperative">
                    </div>

                    <!-- City -->
                    <div class="col-md-6 mb-3">
                        <label class="text-muted">City/Town</label>
                        <input type="text" class="form-control"
                        v-model="city" placeholder="Enter City/Town">
                    </div>

                    <!-- Address -->
                    <div class="col-md-12 mb-3">
                        <label class="text-muted">Full Address</label>
                        <textarea class="form-control" rows="2"
                        v-model="address" placeholder="Enter address"></textarea>
                    </div>

                    </div>
                </div>
                </div>


                <!-- ===================== BULK UPLOAD SECTION ====================== -->
                <div v-if="isBulk" class="px-3">

                <div class="alert alert-info">
                    Upload a CSV file containing multiple farmers.<br>
                    <strong>Required Columns:</strong> firstName, lastName, emailAddress, mobileNumber, dob, address, city
                </div>

                <input type="file"  accept=".xlsx, .xls"  class="form-control mb-3" @change="handleBulkFile">

                <button class="btn btn-primary" @click="uploadBulkFarmers">
                    Upload Excel
                </button>

                </div>

                </div>

                <!-- Footer -->
                <div class="modal-footer d-flex justify-content-end bg-light px-4">
                    <button type="button" class="btn btn-outline-secondary px-4 me-2" @click="closeModal">
                    Cancel
                    </button>
                    <button type="button" class="btn btn-success px-4" @click="submitFarmer">
                    Submit
                    </button>
                </div>

                </div>
            </div>
         </div>

        <p>&nbsp;</p>
        <page-loader :is-loading="isLoading"></page-loader>
    </div>
    </template>
    
      
    <script>
    //import swal from 'sweetalert2';
    import PageLoader from '../components/PageLoader.vue'
    import * as XLSX from "xlsx";
    
    export default {
    
        name: "AllUsersPage",
        components: {
            //quillEditor,
            PageLoader,
        },
    
        data() {
            return {
    
                isLoading: false,
                loading: false,
                loading1: false,
                loading2: false,
                loading3: false,
                role_type: '',
                
                editorOptions: {
                    placeholder: 'Write something...',
                },
    
                img_url: process.env.VUE_APP_IMAGE_URL,
                search: "",
                header: [
                    {
                        value: 'firstname',
                        text: 'First name'
                    },
                    {
                        value: 'lastname',
                        text: 'Last name'
                    },
                    {
                        value: 'middlename',
                        text: 'Middle name'
                    },             
                    {
                        value: 'phone',
                        text: 'Phone'
                    },
                    {
                        value: 'email',
                        text: 'Email'
                    },

                    {
                        value: 'bvn',
                        text: 'BVN'
                    },
                    {
                        value: 'nin',
                        text: 'NIN'
                    },
                   
                    {
                        value: 'dob',
                        text: 'DOB'
                    },
                    {
                        value: 'cooperative',
                        text: 'Cooperative'
                    },
                    {
                        value: 'lga',
                        text: 'LGA'
                    },
                    {
                        value: 'address',
                        text: 'Address'
                    },
                    {
                        value: 'city',
                        text: 'City/Town'
                    },
                    {
                        value: 'state',
                        text: 'State'
                    },
                    
                ],
    
                desserts: [],
                user_role: '',
                createFarmerModel: false,
                // Personal Info
                firstName: '',
                lastName: '',
                middleName: '',

                // Contact
                emailAddress: '',
                mobileNumber: '',

                // Bio Data
                dob: '',

                // Location
                state: '',
                lga: '',
                city: '',
                address: '',
                bvn: '',
                nin: '',
                bvnError: false,
                ninError: false,

                // Organization
                cooperative: '',
               
                states: [
                    'Abia','Adamawa','Akwa Ibom','Anambra','Bauchi','Bayelsa',
                    'Benue','Borno','Cross River','Delta','Ebonyi','Edo',
                    'Ekiti','Enugu','FCT','Gombe','Imo','Jigawa','Kaduna',
                    'Kano','Katsina','Kebbi','Kogi','Kwara','Lagos','Nasarawa',
                    'Niger','Ogun','Ondo','Osun','Oyo','Plateau','Rivers',
                    'Sokoto','Taraba','Yobe','Zamfara'
                ],


                isBulk: false,
                bulkFile: null,
                roles: '',
                modelData: [],
                modelCount: 0

            };
        },
    
        beforeMount() {
    
        },
    
        async mounted() {
    
            this.createdBy = localStorage.getItem("username");
            this.user_id = localStorage.getItem("userid");
            this.roles = localStorage.getItem("roles");
    
            await this.fetchAllFarmers()
        },
    
        created() {
    
        },
    
        computed: {

            indexSn() {
                return this.desserts.map((d, index) => ({
                    ...d,
                    sn: index + 1
                }))
            },
    
        },
    
        methods: {
            validateBVN() {
                // Remove non-digits
                this.bvn = this.bvn.replace(/\D/g, '')

                // Validate length
                this.bvnError = this.bvn.length !== 11
            },

            validateNIN() {
                this.nin = this.nin.replace(/\D/g, '')
                this.ninError = this.nin.length !== 11
            },
            validateNumber() {
            const value = this.delivery_period;
            if (value < 0) {
              this.error = 'Value must be non-negative';
              this.delivery_period = ''
              return
            } else if (!Number.isInteger(Number(value))) {
              this.error = 'Value must be an integer';
              this.delivery_period = ''
              return
            } else {
              this.error = '';
            }
          },
    
            formatToCurrency(value) {
              return value.toLocaleString('en-NG', { minimumFractionDigits: 2 })
            },
    
           
            copied(){
                this.isContractLink = false
            },
    
            copyToClipboard(link) {
               // var copyText = document.getElementById("myInput");
                navigator.clipboard.writeText(link).then(function() {
                    alert("Contract link copied to clipboard!");
                }).catch(function(err) {
                    console.error('Failed to copy: ', err);
                });
            },
    
            copyToClipboard1(link) {
               // var copyText = document.getElementById("myInput");
                navigator.clipboard.writeText(link).then(function() {
                    alert("Contract link copied to clipboard!");
                }).catch(function(err) {
                    console.error('Failed to copy: ', err);
                });
            },
            async submitFarmer() {
                try {
                const response = await this.$http.post("/farmers/create", {
                    firstName: this.firstName,
                    lastName: this.lastName,
                    middleName: this.middleName,
                    emailAddress: this.emailAddress,
                    mobileNumber: this.mobileNumber,
                    dob: this.dob,
                    lga: this.lga,
                    address: this.address,
                    bvn: this.bvn,
                    nin: this.nin,
                    city: this.city,
                    state: this.state,
                    cooperative: this.cooperative,
                    createdBy: this.createdBy,
                });
                    alert(
                        `Farmer created successfully!`
                    );
                    this.fetchAllFarmers()
                    this.closeModal();

                } catch (err) {
                    
                    console.error(err);
                    alert(err.response ? err.response.data.message : err.message)
                }
            },

            handleBulkFile(event) {
            const file = event.target.files[0];
            if (!file) return;

            const fileName = file.name.toLowerCase();

            // Check by extension
            if (!fileName.endsWith(".xlsx") && !fileName.endsWith(".xls")) {
                this.$toast.error("Invalid file type. Please upload an Excel file (.xlsx or .xls)");
                return;
            }

            const reader = new FileReader();

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });

                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                // Convert Excel sheet to JSON
                let json = XLSX.utils.sheet_to_json(sheet, { defval: "" });

                // Append username to every row
                json = json.map(row => ({
                ...row,
                username: this.username
                }));

                this.bulkFile = json; // Now bulkFile is an array of customer objects
                this.$toast.success("File loaded successfully!");
            };

            reader.readAsArrayBuffer(file);
            },

            async uploadBulkFarmers() {
            if (!this.bulkFile || this.bulkFile.length === 0) {
                this.$toast.error("Please select an Excel file and load it first");
                return;
            }

            try {
                // Send the parsed JSON array directly
                const res = await this.$http.post("/farmers/create-bulk", this.bulkFile);

                if (res.data.status === "00") {
                this.$toast.success("Farmers uploaded successfully!");
                // Optionally, clear the file after upload
                this.bulkFile = [];
                } else if (res.data.errors && res.data.errors.length > 0) {
                // Show the first error message
                this.$toast.error(res.data.errors[0]?.message || res.data.message);
                } else {
                this.$toast.error(res.data.message || "Bulk upload failed");
                }
            } catch (err) {
                console.error(err);
                this.$toast.error("Bulk upload failed due to network or server error");
            }
            },

            async fetchAllFarmers() {
                try {
                    this.isLoading = true
                    this.desserts = []
                    const response = await this.$http.get(`/farmers/fetch-all`, {

                    })
                    this.isLoading = false
                    
                    this.modelData = response.data.data
                    this.modelCount = this.modelData.length
                    this.modelData.forEach(el => {
                        this.desserts.push({
                            farmerId: el.farmerId,
                            firstname: el.firstName,
                            lastname: el.lastName,
                            middlename: el.middleName,
                            phone: el.mobileNumber,
                            email: el.emailAddress,
                            bvn: el.bvn,
                            nin: el.nin,
                            dob: new Date(el.dob).toDateString(),
                            cooperative: el.cooperative,
                            lga: el.lga,
                            address: el.address,
                            city: el.city,
                            state: el.state
                        })
                    });
    
                } catch (err) {
                    alert(err.response ? err.response.data.message : err.message)
                    this.isLoading = false
                    //this.$router.push('/home')
                    console.log(err);
                }
            },

            createFarmer() {
                this.createFarmerModel = true;
            },
            closeModal() {
                this.createFarmerModel = false;
            },
    
        }
    
    }
    </script>
      
    <style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap');
    
    .farmer-table {
      font-size: 12px !important;
    }

    .farmer-table .v-data-table-header th {
      font-size: 12px !important;
    }

    .farmer-table tbody td {
      font-size: 12px !important;
    }

    /* Backdrop */
    .modal-backdrop-custom {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    }

    /* Modal wrapper (center container) */
    .modal-wrapper {
        width: 100%;
        max-width: 600px;
    }

    /* Header */
    .subs-content {
    padding: 0.5rem;
    background-color: #D33E74; /* Bootstrap success green */
    }
    .btn-success{
        background-color: #D33E74; 
        border: 0px;
    }
    .btn-xs{
        padding: 0.2rem;
        border: 0px;
        font-family: Poppins;
        font-size: 12px;
        font-weight: 500;
    }
    .modal-footer{
        padding: 0.5rem;
    }
    /* User info */
    .user-info p {
    font-size: 1rem;
    color: #222;
    border-bottom: 1px solid #f1f1f1;
    padding-bottom: 8px;
    }
    .user-info p:last-child {
    border-bottom: none;
    }

    .user-info strong {
  display: block;
  font-size: 0.9rem;
  margin-bottom: 4px;
  color: #6c757d;
}
.user-info div {
  font-size: 1rem;
  color: #212529;
  font-weight: 500;
}

    .error {
        color: #fff;
      }
      .error1 {
        color: #fff;
      }
    .quill-container {
        height: 200px;
        /* Set the desired height here */
    }
    .copy-refid{
        cursor: pointer;
        font-size: 16px;
    }
    .copy-refid1{
        cursor: pointer;
        font-size: 15px;
        font-weight: 600;
    }
    .a-text {
        font-size: 12px;
        font-family: Poppins;
    }
    .a-text1 {
        font-size: 14px;
        font-family: Poppins;
    }
    .process-payment{
        cursor:pointer;
    
    }
    label {
        font-size: 12px;
        font-family: Poppins;
        font-weight: normal;
    }
    
    .inputs {
        margin-top: 20px;
        border-radius: 3px;
        font-size: 12px;
    }
    
    .price-fee {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    
        div {
            margin: 4px;
            width: 100%;
    
        }
    }
    
    .adjust-fee-input {
        // width: 100px;
        text-align: center;
    }
    
    .whopays-fee-input {
        //width: 100% !important;
    }
    
    .shop-detail {
        font-size: 12px;
        font-family: Poppins;
    }
    
    .btn-danger {
        text-transform: uppercase;
        font-size: 13px;
        font-family: Poppins;
        background: #D33E74;
        border: 0px;
        height: 45px;
    }
    
    .text-header {
        padding: 0.5rem;
        font-size: 14px;
        font-weight: bold;
        font-family: Poppins;
        background: #ccc;
    }
    
    .contract-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: #D33E74;
        color: #fff;
        border-radius: 4px;
        padding: 0.8rem;
        font-size: 14px;
        font-weight: 700;
        font-family: Poppins;
        margin-bottom: 5px;
    }
    
    .welcome {
        font-family: Poppins;
        font-size: 20px;
        font-weight: 700;
        margin-top: 15px;
        color: #170e0fac;
    }
    
    .account-details {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        //padding: 0.9rem;
        background: #fff;
        width: 100%;
    }
    
    .account-balance {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: #780712;
        color: #fff;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        font-family: Poppins;
        padding: 0.4rem;
        padding-left: 2rem;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .wallet-detail {
        padding-top: 1rem;
        line-height: 1.4px;
        font-size: 15px;
    
        h4 {
            font-weight: 650;
        }
    
        .acct-d {
            line-height: 0.8;
            cursor: pointer;
            text-decoration: underline;
        }
    }
    
    .wallet-icon {
        font-size: 60px
    }
    
    .fund-account {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: #076378;
        color: #fff;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        font-family: Poppins;
        padding: 0.4rem;
        padding-left: 2rem;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .inputs-field {
        font-size: 14px;
        font-family: Poppins;
        height: 45px;
    }
    
    .content-center {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border: solid 1px #170e0fac;
        border-radius: 4px;
        padding: 0.5rem;
        margin: 4px;
    }
    
    .box1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .image-input {
        margin-top: 10px;
    }
    
    .box-icon {
        padding-left: 0.4rem;
        font-size: 35px;
        color: #637807;
    }
    
    .box-details {
        font-size: 14px;
        color: #170e0fac;
    }
    
    .box1:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box2:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box3 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box3:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box4 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box4:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box5 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box5:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box6 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box6:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .img {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
    
    .box-details {
        padding: 0.4rem;
        line-height: 1.4px;
    
        .title {
            font-family: Poppins;
            font-weight: 550;
            font-size: 10px;
            text-transform: capitalize;
            color: #ff4d63;
        }
    
        .description {
            font-family: Poppins;
            font-size: 12px;
        }
    }
    
    .continue {
        display: flex;
        flex-direction: row;
        justify-content: right;
        padding-right: 0.4rem;
        font-size: 30px;
        color: rgb(237, 138, 108);
        margin-right: 10px;
        margin-top: -10px;
        margin-bottom: 10px;
    }
    
    .modal-mask {
        position: fixed;
        //z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .4s ease;
    
        &>div {
            width: 90%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #fff;
            ;
            backdrop-filter: blur(13px);
            border-radius: 10px;
            box-sizing: border-box;
            font-family: Poppins;
        }
    
        h3 {
            margin-top: 10px;
            font-size: 18px;
            color: #000;
            font-weight: bold;
            font-family: Poppins;
        }
    }
    
    .account-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
    .account-content-h {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50px;
    
        padding-top: 1.3rem;
        text-transform: uppercase;
        text-align: center;
        //text-decoration: underline;
    }
    
    .add-fund {
        font-size: 12px;
        text-decoration: none !important;
        text-transform: capitalize;
    }
    
    .account-content-d {
        padding-top: 1.3rem;
        font-size: 14px;
        margin-bottom: 10px;
    }
    
    .btn-secondary {
        text-transform: uppercase;
    }
    
    .modal-close {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    }
    
    .modal-close-mobile {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    
        display: none;
    }
    
    a {
        text-decoration: none;
    }
    
    .shop-name {
        //font-weight: 550;
        color: #000;
        font-family: Poppins;
    }
    /* Scrollable Body */
    .modal-body-scroll {
    overflow-y: auto;
    max-height: calc(95vh - 130px);
    }
    @media screen and (max-width: 768px) {
        .modal-wrapper {
            padding: 20px;
        }
        .modal-subs {
            height: 95vh;
            border-radius: 12px;
        }

        .modal-body-scroll {
            max-height: calc(95vh - 120px);
            overflow-y: auto;
            -webkit-overflow-scrolling: touch; /* Smooth iOS scroll */
        }
        .copy-refid1{
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
        }
        .inputs-field {
            font-size: 12px;
            font-family: Poppins;
            font-weight: normal;
            height: 45px;
        }
        .contract-header {
    
            font-size: 12px !important;
    
        }
    
        .counter {
            font-size: 13px;
            font-weight: 500 !important;
        }
    
        .welcome {
            font-family: Poppins;
            font-size: 16px;
            font-weight: 700;
            text-align: left;
            color: #170e0fac;
        }
    
        .content-center {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 0.9rem;
        }
    
        .image-input {
            margin-top: 20px;
        }
    
        .price-fee {
            display: flex;
            flex-direction: column;
    
            div {
                width: 100%;
            }
        }
        .margin-mobile{
            margin-top: 90px;;
        }
    
        .adjust-fee-input {
            width: 100%;
        }
    
        .account-details {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            width: 100%;
        }
    
        .account-balance {
            margin-bottom: 10px;
        }
    
        .box-details {
            padding: 0.4rem;
            line-height: 1.4px;
    
            .title {
                font-family: Poppins;
                font-weight: 550;
                font-size: 8px;
                text-transform: capitalize;
                color: #ff4d63;
            }
    
            .description {
                font-family: Poppins;
                font-size: 12px;
            }
        }
    
        .inputs {
            font-size: 12px;
        }
    
        .box1 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box2 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box3 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box4 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box5 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .continue {
            display: flex;
            flex-direction: row;
            justify-content: right;
            padding-right: 0.4rem;
            font-size: 30px;
            margin-top: -10px;
            color: rgb(237, 138, 108);
        }
    
        .modal-close-mobile {
            display: block;
        }
    
        .modal-close {
            display: none;
        }
    
        .account-content {
            margin: 0px;
            margin-right: 0px;
        }
    
    }
    </style>
    